module.exports = __webpack_public_path__ + "static/media/period_ban_red.85e6caae.svg";